module.exports = __webpack_public_path__ + "static/33-afb9e773db43e06620986613d1b07f25.png";